module.exports = __webpack_public_path__ + "9a9bc732b5addf34d95947c143b50758.png";